/* Candywrap v2 homepage: gedeelde mand-helper, Mixbox, recent bekeken en Mystery budget. */
(function () {
  if (window.cwHome) return;

  var fmt = function (c) { return (c / 100).toFixed(2).replace('.', ','); };

  /* Producten in de mand via de standaard Shopify route, daarna de bestaande mandlade verversen en openen. */
  function add(items, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    return fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    }).then(function (d) {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: btn } }));
      }, 150);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (btn) {
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1400);
      }
      return d;
    }).catch(function (e) {
      var msg = (e && (e.description || e.message)) || 'Dit kon niet in je mand. Probeer het nog eens.';
      alert(msg);
      throw e;
    }).finally(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
    });
  }

  /* Snelle plusknoppen op productkaarten */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cw-add]');
    if (!b) return;
    e.preventDefault();
    var item = { id: +b.getAttribute('data-cw-add'), quantity: 1 };
    var prop = b.getAttribute('data-cw-prop');
    if (prop) { var p = {}; p[prop.split('|')[0]] = prop.split('|')[1]; item.properties = p; }
    add([item], b).catch(function () {});
  });

  /* Mandtotaal ophalen voor de cadeauladder */
  var cartTotal = 0, listeners = [];
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartTotal = c.total_price || 0; listeners.forEach(function (f) { f(cartTotal); }); })
      .catch(function () {});
  }
  var lt;
  function cartChanged() { clearTimeout(lt); lt = setTimeout(loadCart, 300); }
  ['on:cart:add', 'cart:updated', 'on:line-item:change', 'dispatch:cart-drawer:refresh'].forEach(function (ev) { document.addEventListener(ev, cartChanged); });
  try {
    new PerformanceObserver(function (l) {
      l.getEntries().forEach(function (en) { if (/\/cart\/(add|change|update|clear)/.test(en.name)) cartChanged(); });
    }).observe({ type: 'resource', buffered: false });
  } catch (e) {}

  window.cwHome = { add: add, fmt: fmt, onCart: function (f) { listeners.push(f); f(cartTotal); }, loadCart: loadCart };
  loadCart();
})();

/* ---------- Mixbox ---------- */
(function () {
  function init(root) {
    if (root.__cw) return; root.__cw = true;
    var data = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    var steps = data.steps; /* [[cent, label], ...] */
    var state = { fl: data.lists[0].key, order: [], mode: 'mix' };
    var byHandle = {}; data.mixes.forEach(function (m) { byHandle[m.h] = m; });
    var $ = function (s) { return root.querySelector(s); };
    var fmt = cwHome.fmt;
    var cart = 0, giftCache = {}, giftLoading = {};
    function preload(key) {
      if (giftCache[key] || giftLoading[key] || !data.giftHandles || !data.giftHandles[key]) return;
      giftLoading[key] = true;
      fetch('/collections/' + data.giftHandles[key] + '?sort_by=best-selling&section_id=cw-gift-render')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var dv = document.createElement('div'); dv.innerHTML = html;
          var arr = [].map.call(dv.querySelectorAll('[data-g]'), function (x) { return { t: x.getAttribute('data-g'), img: x.getAttribute('data-img') }; });
          var tt = dv.querySelector('[data-total]'); arr.total = tt ? +tt.getAttribute('data-total') : arr.length; arr.max = tt ? +tt.getAttribute('data-max') : 0;
          if (arr.length) { giftCache[key] = arr; render(); }
        }).catch(function () {});
    }

    /* segment: Pak een mix / Schep je eigen */
    root.querySelectorAll('[data-seg]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.mode = b.getAttribute('data-seg');
        root.querySelectorAll('[data-seg]').forEach(function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-selected', on); });
        $('[data-mode="mix"]').hidden = state.mode !== 'mix';
        $('[data-mode="pm"]').hidden = state.mode !== 'pm';
      });
    });

    /* smaakfilter */
    var chips = $('.chips');
    data.lists.forEach(function (l) {
      var c = document.createElement('button');
      c.type = 'button'; c.className = 'chip'; c.textContent = l.name; c.setAttribute('data-fl', l.key);
      c.addEventListener('click', function () { state.fl = l.key; render(); });
      chips.appendChild(c);
    });

    function qty(h) { return state.order.filter(function (x) { return x === h; }).length; }
    function setQ(h, d) {
      if (d > 0) { var m = byHandle[h]; if (!m || !m.a) return; state.order.push(h); }
      else { var j = state.order.lastIndexOf(h); if (j < 0) return; state.order.splice(j, 1); }
      render();
    }

    var grid = $('.mixes');
    function renderMixes() {
      var list = data.lists.filter(function (l) { return l.key === state.fl; })[0];
      grid.innerHTML = '';
      list.items.forEach(function (h, i) {
        var m = byHandle[h]; if (!m || !m.a) return;
        var q = qty(h);
        var el = document.createElement('div');
        el.className = 'mx' + (m.a ? '' : ' is-out');
        el.innerHTML =
          '<a class="st" href="' + m.u + '" style="background:' + data.bgs[i % data.bgs.length] + '">' +
            (m.img ? '<img src="' + m.img + '" alt="' + m.t.replace(/"/g, '&quot;') + '" loading="lazy" width="300" height="300">' : '') +
            (data.mixes[0] && m.p < data.mixes[0].p ? '<span class="opop">Nu ' + fmt(m.p) + '</span>' : '') +
          '</a>' +
          '<span><b>' + m.n + '</b></span>' +
          '<span class="qty"><button type="button" class="min" aria-label="' + m.t + ' uit je box halen"' + (q ? '' : ' disabled') + '>−</button>' +
          '<b>' + q + '</b><button type="button" class="pl" aria-label="' + m.t + ' toevoegen aan je box"' + (m.a ? '' : ' disabled') + '>+</button></span>';
        el.querySelector('.min').addEventListener('click', function () { setQ(h, -1); });
        el.querySelector('.pl').addEventListener('click', function () { setQ(h, 1); });
        grid.appendChild(el);
      });
    }

    function render() {
      chips.querySelectorAll('.chip').forEach(function (c) { var on = c.getAttribute('data-fl') === state.fl; c.classList.toggle('on', on); c.setAttribute('aria-pressed', on); });
      renderMixes();
      var ord = state.order, count = ord.length;
      var raw = ord.reduce(function (s, h) { return s + byHandle[h].p; }, 0);
      var tot = cart + raw;
      /* vakjes: nieuwste linksboven, bij meer dan 8 een +teller */
      var filled = ord.slice().reverse();
      var nSlots = Math.max(4, Math.min(count, 8));
      var slots = $('.slots'); slots.innerHTML = '';
      for (var i = 0; i < nSlots; i++) {
        var s = document.createElement('span');
        var h = filled[i];
        s.className = 'slot' + (h ? ' full' : '');
        if (h) {
          s.innerHTML = '<img src="' + byHandle[h].img + '" alt="">' + (count > 8 && i === 7 ? '<b class="more">+' + (count - 7) + '</b>' : '') +
            '<button type="button" class="rm" aria-label="' + byHandle[h].t.replace(/"/g, '&quot;') + ' uit je box halen">×</button>';
          (function (idx) {
            s.querySelector('.rm').addEventListener('click', function () { state.order.splice(idx, 1); render(); });
          })(count - 1 - i);
        } else s.textContent = '+';
        slots.appendChild(s);
      }
      $('[data-count]').textContent = count === 1 ? '1 mix' : count + ' mixen';
      /* cadeauladder: 5 treden rond de volgende stap */
      var nxt = null, ni = steps.length;
      for (var k = 0; k < steps.length; k++) { if (tot < steps[k][0]) { nxt = steps[k]; ni = k; break; } }
      var st0 = Math.max(0, Math.min(ni - 3, steps.length - 5));
      var shown = steps.slice(st0, st0 + 5);
      var lo = st0 ? steps[st0 - 1][0] : 0, hi = shown[shown.length - 1][0];
      var sc = function (v) { return Math.max(0, Math.min(100, Math.round((v - lo) / (hi - lo) * 100))); };
      $('.ladbar i').style.width = sc(tot) + '%';
      $('.ladbar').querySelectorAll('.lm').forEach(function (x) { x.remove(); });
      shown.forEach(function (t) {
        var m = document.createElement('span'); m.className = 'lm' + (tot >= t[0] ? ' hit' : ''); m.style.left = sc(t[0]) + '%'; $('.ladbar').appendChild(m);
      });
      $('.ladl').innerHTML = shown.map(function (t) {
        return '<li class="' + (tot >= t[0] ? 'hit' : '') + '"><span class="ld"></span><span>' + t[1] + '</span><b>vanaf ' + (t[0] / 100) + '</b></li>';
      }).join('');
      var avg = count ? raw / count : (data.mixes[0] ? data.mixes[0].p : 1399);
      var nMix = nxt ? Math.ceil((nxt[0] - tot) / avg) : 0;
      var nxtName = nxt ? (/verzending/i.test(nxt[1]) ? 'gratis verzending' : 'je ' + nxt[1].replace(/\D+/g, '') + 'e cadeau') : '';
      $('.ladn').textContent = !nxt ? 'Je hebt alle cadeaus vrijgespeeld' : (count === 0 && cart === 0 ? 'Kies je eerste mix' : 'Nog ' + nMix + (nMix === 1 ? ' mix' : ' mixen') + ' voor ' + nxtName);
      var gbox = $('[data-gifts]');
      if (gbox && data.gifts) {
        var tierSteps = steps.filter(function (s) { return !/verzending/i.test(s[1]); });
        var nextG = tierSteps.filter(function (s) { return tot < s[0]; })[0];
        var showG = nextG || tierSteps[tierSteps.length - 1];
        var key = showG ? String(showG[0]) : '';
        var list = showG ? ((giftCache[key]) || data.gifts[key] || []) : [];
        if (showG && !giftCache[key] && !giftLoading[key] && data.giftHandles && data.giftHandles[key]) {
          giftLoading[key] = true;
          fetch('/collections/' + data.giftHandles[key] + '?sort_by=best-selling&section_id=cw-gift-render')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var dv = document.createElement('div'); dv.innerHTML = html;
              var arr = [].map.call(dv.querySelectorAll('[data-g]'), function (x) { return { t: x.getAttribute('data-g'), img: x.getAttribute('data-img') }; });
              var tt = dv.querySelector('[data-total]'); arr.total = tt ? +tt.getAttribute('data-total') : arr.length; arr.max = tt ? +tt.getAttribute('data-max') : 0; if (arr.length) { giftCache[key] = arr; render(); }
            }).catch(function () {});
        }
        if (list.length) {
          var nr = tierSteps.indexOf(showG) + 1;
          var mxv = list.max ? ', t.w.v. tot ' + Math.round(list.max / 100) : '';
          gbox.querySelector('.gl').textContent = (nextG ? 'Je ' + nr + 'e cadeau, vanaf ' + (showG[0] / 100) + mxv + ':' : 'Je ' + nr + 'e cadeau' + mxv + ':');
          var five = list.slice(0, 5), rest = (list.total || list.length) - five.length;
          gbox.querySelector('.gimgs').innerHTML = five.map(function (g) { var t = g.t.replace(/"/g, '&quot;'); return '<span title="' + t + '"><img src="' + g.img + '" alt="' + t + '" loading="lazy"></span>'; }).join('') + (rest > 0 ? '<span class="gmore">+' + rest + '</span>' : '');
          gbox.hidden = false;
        } else gbox.hidden = true;
      }
      var gv = $('[data-giftvalue]');
      if (gv && data.giftHandles) {
        var sum = 0, haveAll = true;
        steps.forEach(function (s) {
          if (/verzending/i.test(s[1]) || tot < s[0]) return;
          var c = giftCache[String(s[0])];
          if (c && c.max) sum += c.max; else { haveAll = false; preload(String(s[0])); }
        });
        gv.hidden = !(sum > 0);
        gv.textContent = 'Je krijgt nu tot ' + Math.round(sum / 100) + ' euro aan cadeaus gratis';
      }
      var cb = $('[data-cartbox]');
      if (cb) { cb.hidden = !(cart > 0); $('[data-cartamt]').textContent = fmt(cart); }
      $('[data-total]').textContent = cwHome.fmt(raw);
      $('[data-totnote]').innerHTML = cart > 0 ? 'Box ' + fmt(raw) + ' + mand ' + fmt(cart) + ' = <b>samen ' + fmt(tot) + '</b>' : (count === 1 ? '1 mix van 500 g' : count + ' mixen van 500 g');
      var cta = $('[data-cta]');
      cta.textContent = count === 0 ? 'Kies een mix' : 'In mijn mand';
      cta.disabled = count === 0;
    }

    $('[data-cta]').addEventListener('click', function (e) {
      var btn = e.currentTarget;
      if (!state.order.length) return;
      var map = {};
      state.order.forEach(function (h) { map[h] = (map[h] || 0) + 1; });
      var items = Object.keys(map).map(function (h) { return { id: byHandle[h].v, quantity: map[h] }; });
      cwHome.add(items, btn).then(function () { state.order = []; render(); }).catch(function () {});
    });

    var intro = $("[data-intro]");
    if (intro && data.mixes.length) {
      var p0 = data.mixes[0].p;
      var ship = steps.filter(function (s) { return /verzending/i.test(s[1]); })[0];
      intro.textContent = intro.textContent.replace("[prijs]", fmt(p0)).replace("[aantal]", ship ? Math.ceil(ship[0] / p0) : 4);
    }
    cwHome.onCart(function (t) { cart = t; render(); });
    render();
  }
  function boot() { document.querySelectorAll('[data-cw-mixbox]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

/* ---------- Verder waar je was (recent bekeken, alleen als er iets is) ---------- */
(function () {
  function init(root) {
    if (root.__cw) return; root.__cw = true;
    var ids = [];
    try { ids = JSON.parse(localStorage.getItem('cc-recently-viewed') || '[]'); } catch (e) {}
    ids = ids.slice(0, 6);
    if (!ids.length) return;
    var q = ids.map(function (id) { return 'id:' + id; }).join(' OR ');
    fetch('/search?type=product&section_id=cw-recent-render&q=' + encodeURIComponent(q))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var cards = d.querySelectorAll('[data-rid]');
        if (!cards.length) return;
        var byId = {}; cards.forEach(function (c) { byId[c.getAttribute('data-rid')] = c; });
        var box = root.querySelector('.recent'); box.innerHTML = '';
        ids.forEach(function (id) { if (byId[id]) box.appendChild(byId[id]); });
        root.hidden = false;
      }).catch(function () {});
  }
  function boot() { document.querySelectorAll('[data-cw-recent]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();

/* ---------- Mystery Box budget ---------- */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cw-budget]');
    if (!b) return;
    var wrap = b.closest('.myst');
    wrap.querySelectorAll('[data-cw-budget]').forEach(function (x) { var on = x === b; x.classList.toggle('on', on); x.setAttribute('aria-checked', on); });
    var a = wrap.querySelector('[data-cw-budget-link]');
    if (a) { var u = new URL(a.href, location.origin); u.searchParams.set('budget', b.getAttribute('data-cw-budget')); a.href = u.pathname + u.search; }
  });
})();

/* ---------- vaste elementen onder de sticky header laten beginnen ---------- */
(function () {
  function set() {
    var h = document.querySelector('.cc-header--sticky, store-header');
    if (!h) return;
    var sec = h.closest('.shopify-section') || h;
    document.documentElement.style.setProperty('--cw-stick', Math.round(sec.getBoundingClientRect().height + 16) + 'px');
  }
  window.addEventListener('resize', set);
  window.addEventListener('load', set);
  if (document.readyState !== 'loading') set(); else document.addEventListener('DOMContentLoaded', set);
})();


/* ---------- Maatchips op productkaarten ---------- */
(function () {
  if (window.__cwVchips) return; window.__cwVchips = true;
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('.cw-vchip');
    if (chip) {
      e.preventDefault();
      var box = chip.closest('[data-cw-vchips]');
      box.querySelectorAll('.cw-vchip').forEach(function (c) { c.setAttribute('aria-checked', c === chip ? 'true' : 'false'); });
      var pr = box.parentElement.querySelector('[data-cw-vprice]');
      if (pr) { var p = (chip.getAttribute('data-p') || '').split(','); var c = chip.getAttribute('data-c'); pr.innerHTML = '<b>' + p[0] + '<sup>' + (p[1] || '00') + '</sup></b>' + (c ? '<s>' + c + '</s>' : ''); }
      return;
    }
    var btn = e.target.closest && e.target.closest('.js-quick-add');
    if (!btn) return;
    var card = btn.closest('product-card');
    var sel = card && card.querySelector('.cw-vchip[aria-checked="true"]');
    if (!sel) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var items = [{ id: parseInt(sel.getAttribute('data-v'), 10), quantity: 1 }];
    if (window.cwHome && window.cwHome.add) { window.cwHome.add(items, btn); return; }
    btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function () { btn.classList.remove('is-loading'); document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); })
      .catch(function () { btn.classList.remove('is-loading'); });
  }, true);
})();

/* Mixbox telefoon: box-balk open- en dichtklappen */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-bptgl]'); if (!b) return;
  var p = b.closest('.bpanel'); var open = !p.classList.contains('is-open');
  p.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
});

/* uitgelichte bundel: direct in de winkelwagen en lade openen */
(function () {
  if (window.__cwFeatAdd) return; window.__cwFeatAdd = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cw-feat-add]'); if (!b || b.disabled) return;
    e.preventDefault(); b.disabled = true; var t = b.textContent; b.textContent = 'Bezig...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-cw-feat-add'), 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { b.textContent = 'Toegevoegd'; document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true })); document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true })); })
      .catch(function () { b.textContent = 'Lukt niet, probeer opnieuw'; })
      .then(function () { setTimeout(function () { b.disabled = false; b.textContent = t; }, 1800); });
  });
})();


/* maatkeuze in uitgelichte kaarten (seizoenskop en spotlight in collectie) */
(function () {
  if (window.__cwshV) return; window.__cwshV = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cwsh] .cwsh-v'); if (!b) return;
    var card = b.closest('[data-cwsh]');
    card.querySelectorAll('.cwsh-v').forEach(function (x) { x.classList.toggle('on', x === b); });
    var add = card.querySelector('[data-cw-feat-add]'); if (add) add.setAttribute('data-cw-feat-add', b.getAttribute('data-v'));
    var p = card.querySelector('[data-cwsh-p]'); if (p) p.textContent = b.getAttribute('data-p');
    var c = card.querySelector('[data-cwsh-c]'), cv = b.getAttribute('data-c'); if (c) { c.textContent = cv; c.hidden = !cv; }
  });
})();

/* filters op mobiel/tablet: de knop onthoudt de desktop-stand (open), waardoor de eerste tik niets deed. Stand gelijk trekken met het paneel. */
(function () {
  if (window.__cwFilterFix) return; window.__cwFilterFix = true;
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.js-toggle-filters'); if (!t) return;
    if (window.theme && theme.mediaMatches && theme.mediaMatches.lg) return;
    var f = document.getElementById('facet-filters');
    var open = !!(f && f.classList.contains('is-open'));
    t.classList.toggle('is-active', open);
  }, true);
})();
